import * as React from "react";
function SvgWechat(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        d="M29 19.23c0-3.61-3.51-6.52-7.83-6.52s-7.83 2.91-7.83 6.52 3.5 6.5 7.83 6.52a9.85 9.85 0 002.57-.38h.21a.58.58 0 01.41.1l1.7 1a.35.35 0 00.18.06.25.25 0 00.25-.25.48.48 0 000-.2c0-.06-.22-.82-.33-1.31a.6.6 0 010-.23.51.51 0 01.22-.39A6.09 6.09 0 0029 19.23zM18.51 18.1a1 1 0 01-1-1 1 1 0 011-1 1 1 0 110 2m5.2 0a1 1 0 01-1-1 1 1 0 011-1 1 1 0 110 2M3 13.34a7.36 7.36 0 003.26 5.89.51.51 0 01.22.44 1.29 1.29 0 010 .25c-.17.68-.35 1.46-.38 1.57a.65.65 0 00-.06.25.3.3 0 00.31.31.52.52 0 00.16-.05l2.07-1.2a.76.76 0 01.42-.12 2.65 2.65 0 01.38.05 11.33 11.33 0 003.07.38 2.09 2.09 0 00.5 0 6 6 0 01-.31-1.88c0-4 3.84-7.15 8.58-7.15h.5C21 8.36 17.08 5.5 12.4 5.5 7.21 5.5 3 9 3 13.34zm6.2-1.26a1.26 1.26 0 010-2.51 1.26 1.26 0 110 2.51m6.27 0a1.26 1.26 0 111.25-1.25 1.26 1.26 0 01-1.25 1.25"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgWechat);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
